import { HttpServiceResponse } from '../../shared'
import AbstractProvider from '../../shared/abstract.provider'
import { AccEntryXlsxImportTypes } from '../models/accEntry.types'

export class AccEntryXlsxProvider extends AbstractProvider {
  urlPath = 'xlsx_import_file_api'

  public importFile<T>(action: AccEntryXlsxImportTypes, params: Record<string, any>): Promise<HttpServiceResponse<T>> {
    const query = this.query.stringify({
      action,
    })

    return this.http.post(`${this.url}?${query}`, params)
  }

  public importXlsx<T>(params: Record<string, any>): Promise<HttpServiceResponse<T>> {
    const url = this.getCustomUrl('xlsx_import_api')
    return this.http.post(`${url}`, params)
  }
}
